(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-shop-the-look]';

  // Formats cents with the store's own money format (taken from the Liquid
  // money filter via data-money-template), so the JS total matches item prices.
  // Falls back to Intl when the template is missing or the format differs.
  function formatMoney(cents, root) {
    var amount = cents / 100;
    var template = root.getAttribute('data-money-template') || '';
    if (template.indexOf('%AMOUNT%') !== -1) {
      var parts = amount.toFixed(2).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return template.replace('%AMOUNT%', parts.join('.'));
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: root.getAttribute('data-currency') || 'GBP'
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  }

  // Buy 2, Get 1 Free: every group of three ticked pieces gets its cheapest
  // piece free. Sorting high to low, the 3rd, 6th, 9th... pieces are the
  // cheapest of their group, so those prices are the discount.
  function calculateDiscount(prices) {
    if (prices.length < 3) return 0;
    var sorted = prices.slice().sort(function (a, b) {
      return b - a;
    });
    var discount = 0;
    for (var i = 2; i < sorted.length; i += 3) {
      discount += sorted[i];
    }
    return discount;
  }

  function setText(root, selector, text) {
    var el = root.querySelector(selector);
    if (el) {
      el.textContent = text;
    }
  }

  function getSelectedBoxes(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('[data-look-checkbox]'),
      function (box) {
        return box.checked && !box.disabled;
      }
    );
  }

  function updateLook(root) {
    var selected = getSelectedBoxes(root);
    var prices = selected.map(function (box) {
      return parseInt(box.getAttribute('data-price'), 10) || 0;
    });
    var total = prices.reduce(function (sum, price) {
      return sum + price;
    }, 0);

    var discountOn = root.getAttribute('data-discount-enabled') === 'true';
    var discount = discountOn ? calculateDiscount(prices) : 0;
    var finalTotal = total - discount;

    var totalEl = root.querySelector('[data-look-total]');
    if (totalEl) {
      totalEl.textContent = formatMoney(total, root);
      totalEl.classList.toggle('shop-the-look__total-value--struck', discount > 0);
    }

    var discountEl = root.querySelector('[data-look-discount]');
    if (discountEl) {
      discountEl.hidden = discount <= 0;
    }
    setText(root, '[data-look-final]', formatMoney(finalTotal, root));
    setText(root, '[data-look-savings]', formatMoney(discount, root));

    var addButton = root.querySelector('[data-look-add]');
    if (addButton) {
      addButton.disabled = selected.length === 0;
    }
  }

  function setStatus(root, message) {
    var statusEl = root.querySelector('[data-look-status]');
    if (statusEl) {
      statusEl.textContent = message;
    }
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (item) {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        ids.push(item.dataset.sectionId);
      }
    });
    return ids;
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }
    return false;
  }

  function addLookToBag(root, button) {
    var selected = getSelectedBoxes(root);
    if (selected.length === 0) return;

    var items = selected.map(function (box) {
      return { id: parseInt(box.value, 10), quantity: 1 };
    });

    button.disabled = true;
    setStatus(root, 'Adding to bag...');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items, sections: getCartSectionIds().join(',') })
    })
      .then(function (response) {
        return response.json().then(function (body) {
          return { ok: response.ok, body: body };
        });
      })
      .then(function (result) {
        if (!result.ok || result.body.status) {
          throw new Error(result.body.description || result.body.message || 'Could not add the look.');
        }

        return fetch('/cart.js')
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: null,
                  sourceId: root.id || 'shop-the-look',
                  data: {
                    source: 'shop-the-look',
                    itemCount: cart.item_count,
                    sections: result.body.sections
                  }
                }
              })
            );
            return cart;
          });
      })
      .then(function () {
        setStatus(root, 'Added to bag.');
        if (!openCartDrawer()) {
          window.location.href = '/cart';
        }
      })
      .catch(function (error) {
        console.error(error);
        setStatus(root, 'We could not add this look. Please try again.');
      })
      .finally(function () {
        button.disabled = false;
        updateLook(root);
      });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(updateLook);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof HTMLElement) || !target.matches('[data-look-checkbox]')) return;
    var root = target.closest(ROOT_SELECTOR);
    if (root) {
      setStatus(root, '');
      updateLook(root);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-look-add]') : null;
    if (!button) return;
    var root = button.closest(ROOT_SELECTOR);
    if (root) {
      addLookToBag(root, button);
    }
  });

  document.addEventListener('shopify:section:load', initAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
